module.exports = __webpack_public_path__ + "media/images/about-us/media3-6222a3f717a281a7aae94c8f4da22b2b.png";